var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 16,
    fill: "#1E334E",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2364 15.8839C21.6269 15.4933 21.6269 14.8602 21.2364 14.4697C20.8459 14.0791 20.2127 14.0791 19.8222 14.4697L21.2364 15.8839ZM16.7058 19.0003L15.9987 18.2932C15.8111 18.4807 15.7058 18.7351 15.7058 19.0003C15.7058 19.2655 15.8111 19.5199 15.9987 19.7074L16.7058 19.0003ZM19.8222 23.5309C20.2127 23.9214 20.8459 23.9214 21.2364 23.5309C21.6269 23.1404 21.6269 22.5072 21.2364 22.1167L19.8222 23.5309ZM19.8222 14.4697L15.9987 18.2932L17.4129 19.7074L21.2364 15.8839L19.8222 14.4697ZM15.9987 19.7074L19.8222 23.5309L21.2364 22.1167L17.4129 18.2932L15.9987 19.7074Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowStroke);
export default __webpack_public_path__ + "static/media/left-arrow-stroke.c2ba0e1b0e31d86d064af45488a00f28.svg";
export { ForwardRef as ReactComponent };